/*
 *
 *  * Copyright (c) [hoarfroster-frontend] 2026. All Rights Reserved.
 *  *
 *  * Last Modified on May 22, 2026 by hoarfroster
 *
 */

import { createContext, useContext } from 'react';
import { Locale } from '@utils/i18n.base';

// Types moved here so both provider and consumers can import them without circular deps
export interface Preferences {
    preloadMedia?: boolean;
    requireAuthentication?: boolean;
    enableDeviceAuthentication?: boolean;
    hideFooter: boolean;
    serverEndpoint: string;
    backgroundImagePath: string;
    locale: Locale;
}

export interface PreferencesContextType {
    preferences: Preferences;
    updatePreferences: (newPreferences: Partial<Preferences>) => void;
}

export const PreferencesContext = createContext<PreferencesContextType | undefined>(undefined);

export const usePreferences = () => {
    const ctx = useContext(PreferencesContext);
    if (!ctx) throw new Error('usePreferences must be used within a PreferencesProvider');
    return ctx;
};
